var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { isString, omit } from "lodash";
import styled from "styled-components";
import { Select } from "@irati/ui/src/FormItem";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import RewardCatalogueRewardsQuery, { variables } from "@irati/reward/apollo/query/RewardCatalogueRewards";
import RewardRow from "./RewardRow";
/* eslint-disable max-len */
export var customRewardThumbnail = "https://res.cloudinary.com/perkbox/image/upload/v1552919889/eac9df93-c2a6-4f6d-8a50-654de1bd3a4e.png";
/* eslint-enable max-len */
var PROPERTY = "reward";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n"], ["\n  display: grid;\n"])));
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            rewardSearchText: ""
        };
        _this.buildOptions = function (rewards) {
            return rewards.map(function (reward) {
                return __assign(__assign({}, reward), { desc: reward.header, alt: reward.header, img: reward.thumbnailImage });
            });
        };
        _this.handleChange = function (value, option) {
            var onChange = _this.props.onChange;
            var reward = option.uuid ? omit(option, ["desc", "alt", "img"]) : null;
            var custom = !option.uuid ? option.alt : null;
            return onChange(reward, custom);
        };
        _this.handleRewardList = function (rewardSearchText) {
            _this.setState({ rewardSearchText: rewardSearchText });
        };
        _this.getLabel = function () {
            var required = _this.props.required;
            return required ? "recognition.rewards.picker.search.label.required" : "recognition.rewards.picker.search.label.optional";
        };
        return _this;
    }
    Search.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, props = __rest(_a, ["intl"]);
        return (React.createElement(RewardCatalogueRewardsQuery, { variables: __assign(__assign({ rewardsForMyPackage: true }, variables), { q: this.state.rewardSearchText }), useLoader: false }, function (_a) {
            var data = _a.data, isLoading = _a.loading;
            if (!data || !data.rewardCatalogueRewards) {
                return [];
            }
            return (React.createElement(StyledDiv, null,
                React.createElement(Select, __assign({}, props, { isCreatable: true, id: id(PROPERTY, _this.props), isValidNewOption: function (option) { return isString(option.label) && option.label.trim() !== ""; }, label: intl.formatMessage({ id: _this.getLabel() }), name: id(PROPERTY, _this.props), onChange: _this.handleChange, onInputChange: _this.handleRewardList, options: _this.buildOptions(data.rewardCatalogueRewards.results), promptTextCreator: function (reward) { return intl.formatMessage({ id: "recognition.fields.poll.reward.promptText" }, { reward: reward }); }, isLoading: isLoading }))));
        }));
    };
    Search.defaultProps = {
        arrowRenderer: null,
        id: "rewardSearch",
        label: "recognition.fields.poll.reward.label",
        labelKey: "alt",
        optionRenderer: RewardRow,
        placeholder: "recognition.fields.poll.reward.placeholder",
        required: false,
        valueKey: "alt",
        valueRenderer: RewardRow
    };
    return Search;
}(Component));
export default injectIntl(Search);
var templateObject_1;
